<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

<div class="cerrix-detail-page" menuSystem [cerrixTab]="tab" (changeEvent)="onMenuItemClick($event)">
    <div
        [attr.name]="'Effectiveness Testing'"
        class="control-testing-detail-page-submenu"
        menuicon="far fa-glasses-alt"
        menusystemsubmenu
    >
        <div
            [attr.name]="'effDetail.details' | t"
            menuItemId="Details"
            class="control-testing-detail-page-new-wrapper"
            menuicon="fas fa-info-circle"
            menusystemitem
        >
            <eff-detail-main
                class="control-testing-detail-page-new"
                [cerrixTab]="tab"
                [effectivenessGuid]="effectivenessGuid"
            ></eff-detail-main>
        </div>

        <div [attr.name]="'effDetail.links' | t" menuItemId="Links" menuicon="fas fa-link" menusystemsubmenu>
            <div [attr.name]="'effDetail.risks' | t" menuItemId="Risks" menuicon="fas fa-exclamation-triangle" menusystemitem>
                <div class="detail-page-card">
                    <div class="detail-page-card-title">{{ 'effDetail.linkedRisks' | t }}</div>
                    <div class="detail-page-card-body padded cerrix-compact">
                        <adv-eff-linked-risks
                            [linkedRisks]="linkedRisks$ | async"
                            (riskClicked)="openRisk($event)"
                        >
                        </adv-eff-linked-risks>
                    </div>
                </div>
            </div>
        </div>

        <div [attr.name]="'effDetail.workflowHistory' | t" menuItemId="Workflow history" menuicon="fas fa-history" menusystemitem>
            <eff-detail-workflow-history
                #workflowHistory
                [effectivenessGuid]="effectivenessGuid"
            ></eff-detail-workflow-history>
        </div>
    </div>
</div>
